const D="GraphQL Client";const J="An error occurred while fetching from the API. Review 'graphQLErrors' for details.",Q="Response returned unexpected Content-Type:",K="An unknown error has occurred. The API did not return a data object or any errors in its response.",U={json:"application/json",multipart:"multipart/mixed"},V="X-SDK-Variant",O="X-SDK-Version",ie="shopify-graphql-client",se="1.4.1",Y=1e3,ce=[429,503],X=/@(defer)\b/i,L=`\r
`,ue=/boundary="?([^=";]+)"?/i,B=L+L;function h(r,t=D){return r.startsWith(`${t}`)?r:`${t}: ${r}`}function A(r){return r instanceof Error?r.message:JSON.stringify(r)}function W(r){return r instanceof Error&&r.cause?r.cause:void 0}function z(r){return r.flatMap(({errors:t})=>t??[])}function Z({client:r,retries:t}){if(t!==void 0&&(typeof t!="number"||t<0||t>3))throw new Error(`${r}: The provided "retries" value (${t}) is invalid - it cannot be less than 0 or greater than 3`)}function g(r,t){return t&&(typeof t!="object"||Array.isArray(t)||typeof t=="object"&&Object.keys(t).length>0)?{[r]:t}:{}}function ee(r,t){if(r.length===0)return t;const n={[r.pop()]:t};return r.length===0?n:ee(r,n)}function te(r,t){return Object.keys(t||{}).reduce((e,n)=>(typeof t[n]=="object"||Array.isArray(t[n]))&&r[n]?(e[n]=te(r[n],t[n]),e):(e[n]=t[n],e),Array.isArray(r)?[...r]:{...r})}function re([r,...t]){return t.reduce(te,{...r})}function le({clientLogger:r,customFetchApi:t=fetch,client:e=D,defaultRetryWaitTime:n=Y,retriableCodes:o=ce}){const a=async(i,c,s)=>{const u=c+1,f=s+1;let l;try{if(l=await t(...i),r({type:"HTTP-Response",content:{requestParams:i,response:l}}),!l.ok&&o.includes(l.status)&&u<=f)throw new Error;const d=(l==null?void 0:l.headers.get("X-Shopify-API-Deprecated-Reason"))||"";return d&&r({type:"HTTP-Response-GraphQL-Deprecation-Notice",content:{requestParams:i,deprecationNotice:d}}),l}catch(d){if(u<=f){const p=l==null?void 0:l.headers.get("Retry-After");return await de(p?parseInt(p,10):n),r({type:"HTTP-Retry",content:{requestParams:i,lastResponse:l,retryAttempt:c,maxRetries:s}}),a(i,u,s)}throw new Error(h(`${s>0?`Attempted maximum number of ${s} network retries. Last message - `:""}${A(d)}`,e))}};return a}async function de(r){return new Promise(t=>setTimeout(t,r))}function fe({headers:r,url:t,customFetchApi:e=fetch,retries:n=0,logger:o}){Z({client:D,retries:n});const a={headers:r,url:t,retries:n},i=me(o),c=le({customFetchApi:e,clientLogger:i,defaultRetryWaitTime:Y}),s=pe(c,a),u=ge(s),f=Ae(s);return{config:a,fetch:s,request:u,requestStream:f}}function me(r){return t=>{r&&r(t)}}async function ne(r){const{errors:t,data:e,extensions:n}=await r.json();return{...g("data",e),...g("extensions",n),headers:r.headers,...t||!e?{errors:{networkStatusCode:r.status,message:h(t?J:K),...g("graphQLErrors",t),response:r}}:{}}}function pe(r,{url:t,headers:e,retries:n}){return async(o,a={})=>{const{variables:i,headers:c,url:s,retries:u,keepalive:f,signal:l}=a,d=JSON.stringify({query:o,variables:i});Z({client:D,retries:u});const p=Object.entries({...e,...c}).reduce((S,[$,R])=>(S[$]=Array.isArray(R)?R.join(", "):R.toString(),S),{});return!p[V]&&!p[O]&&(p[V]=ie,p[O]=se),r([s??t,{method:"POST",headers:p,body:d,signal:l,keepalive:f}],1,u??n)}}function ge(r){return async(...t)=>{if(X.test(t[0]))throw new Error(h("This operation will result in a streamable response - use requestStream() instead."));let e=null;try{e=await r(...t);const{status:n,statusText:o}=e,a=e.headers.get("content-type")||"";return e.ok?a.includes(U.json)?await ne(e):{errors:{networkStatusCode:n,message:h(`${Q} ${a}`),response:e}}:{errors:{networkStatusCode:n,message:h(o),response:e}}}catch(n){return{errors:{message:A(n),...e==null?{}:{networkStatusCode:e.status,response:e}}}}}}async function*ye(r){const t=new TextDecoder;if(r.body[Symbol.asyncIterator])for await(const e of r.body)yield t.decode(e);else{const e=r.body.getReader();let n;try{for(;!(n=await e.read()).done;)yield t.decode(n.value)}finally{e.cancel()}}}function he(r,t){return{async*[Symbol.asyncIterator](){try{let e="";for await(const n of r)if(e+=n,e.indexOf(t)>-1){const o=e.lastIndexOf(t),i=e.slice(0,o).split(t).filter(c=>c.trim().length>0).map(c=>c.slice(c.indexOf(B)+B.length).trim());i.length>0&&(yield i),e=e.slice(o+t.length),e.trim()==="--"&&(e="")}}catch(e){throw new Error(`Error occured while processing stream payload - ${A(e)}`)}}}}function be(r){return{async*[Symbol.asyncIterator](){yield{...await ne(r),hasNext:!1}}}}function Ee(r){return r.map(t=>{try{return JSON.parse(t)}catch(e){throw new Error(`Error in parsing multipart response - ${A(e)}`)}}).map(t=>{const{data:e,incremental:n,hasNext:o,extensions:a,errors:i}=t;if(!n)return{data:e||{},...g("errors",i),...g("extensions",a),hasNext:o};const c=n.map(({data:s,path:u,errors:f})=>({data:s&&u?ee(u,s):{},...g("errors",f)}));return{data:c.length===1?c[0].data:re([...c.map(({data:s})=>s)]),...g("errors",z(c)),hasNext:o}})}function we(r,t){if(r.length>0)throw new Error(J,{cause:{graphQLErrors:r}});if(Object.keys(t).length===0)throw new Error(K)}function Me(r,t){var c,s;const e=(t??"").match(ue),n=`--${e?e[1]:"-"}`;if(!((c=r.body)!=null&&c.getReader)&&!((s=r.body)!=null&&s[Symbol.asyncIterator]))throw new Error("API multipart response did not return an iterable body",{cause:r});const o=ye(r);let a={},i;return{async*[Symbol.asyncIterator](){var u;try{let f=!0;for await(const l of he(o,n)){const d=Ee(l);i=((u=d.find(b=>b.extensions))==null?void 0:u.extensions)??i;const p=z(d);a=re([a,...d.map(({data:b})=>b)]),f=d.slice(-1)[0].hasNext,we(p,a),yield{...g("data",a),...g("extensions",i),hasNext:f}}if(f)throw new Error("Response stream terminated unexpectedly")}catch(f){const l=W(f);yield{...g("data",a),...g("extensions",i),errors:{message:h(A(f)),networkStatusCode:r.status,...g("graphQLErrors",l==null?void 0:l.graphQLErrors),response:r},hasNext:!1}}}}}function Ae(r){return async(...t)=>{if(!X.test(t[0]))throw new Error(h("This operation does not result in a streamable response - use request() instead."));try{const e=await r(...t),{statusText:n}=e;if(!e.ok)throw new Error(n,{cause:e});const o=e.headers.get("content-type")||"";switch(!0){case o.includes(U.json):return be(e);case o.includes(U.multipart):return Me(e,o);default:throw new Error(`${Q} ${o}`,{cause:e})}}catch(e){return{async*[Symbol.asyncIterator](){const n=W(e);yield{errors:{message:h(A(e)),...g("networkStatusCode",n==null?void 0:n.status),...g("response",n)},hasNext:!1}}}}}}function Se({client:r,storeDomain:t}){try{if(!t||typeof t!="string")throw new Error;const e=t.trim(),n=e.match(/^https?:/)?e:`https://${e}`,o=new URL(n);return o.protocol="https",o.origin}catch(e){throw new Error(`${r}: a valid store domain ("${t}") must be provided`,{cause:e})}}function oe({client:r,currentSupportedApiVersions:t,apiVersion:e,logger:n}){const o=`${r}: the provided apiVersion ("${e}")`,a=`Currently supported API versions: ${t.join(", ")}`;if(!e||typeof e!="string")throw new Error(`${o} is invalid. ${a}`);const i=e.trim();t.includes(i)||(n?n({type:"Unsupported_Api_Version",content:{apiVersion:e,supportedApiVersions:t}}):console.warn(`${o} is likely deprecated or not supported. ${a}`))}function I(r){const t=r*3-2;return t===10?t:`0${t}`}function j(r,t,e){const n=t-e;return n<=0?`${r-1}-${I(n+4)}`:`${r}-${I(n)}`}function $e(){const r=new Date,t=r.getUTCMonth(),e=r.getUTCFullYear(),n=Math.floor(t/3+1);return{year:e,quarter:n,version:`${e}-${I(n)}`}}function Ce(){const{year:r,quarter:t,version:e}=$e(),n=t===4?`${r+1}-01`:`${r}-${I(t+1)}`;return[j(r,t,3),j(r,t,2),j(r,t,1),e,n,"unstable"]}function _e(r){return t=>({...t??{},...r.headers})}function Te({getHeaders:r,getApiUrl:t}){return(e,n)=>{const o=[e];if(n&&Object.keys(n).length>0){const{variables:a,apiVersion:i,headers:c,retries:s,signal:u}=n;o.push({...a?{variables:a}:{},...c?{headers:r(c)}:{},...i?{url:t(i)}:{},...s?{retries:s}:{},...u?{signal:u}:{}})}return o}}const q="application/json",Re="storefront-api-client",xe="1.0.9",Ie="X-Shopify-Storefront-Access-Token",De="Shopify-Storefront-Private-Token",ve="X-SDK-Variant",je="X-SDK-Version",ke="X-SDK-Variant-Source",_="Storefront API Client";function Ue(r){if(r&&typeof window<"u")throw new Error(`${_}: private access tokens and headers should only be used in a server-to-server implementation. Use the public API access token in nonserver environments.`)}function Ne(r,t){if(!r&&!t)throw new Error(`${_}: a public or private access token must be provided`);if(r&&t)throw new Error(`${_}: only provide either a public or private access token`)}function Pe({storeDomain:r,apiVersion:t,publicAccessToken:e,privateAccessToken:n,clientName:o,retries:a=0,customFetchApi:i,logger:c}){const s=Ce(),u=Se({client:_,storeDomain:r}),f={client:_,currentSupportedApiVersions:s,logger:c};oe({...f,apiVersion:t}),Ne(e,n),Ue(n);const l=Fe(u,t,f),d={storeDomain:u,apiVersion:t,...e?{publicAccessToken:e}:{privateAccessToken:n},headers:{"Content-Type":q,Accept:q,[ve]:Re,[je]:xe,...o?{[ke]:o}:{},...e?{[Ie]:e}:{[De]:n}},apiUrl:l(),clientName:o},p=fe({headers:d.headers,url:d.apiUrl,retries:a,customFetchApi:i,logger:c}),b=_e(d),S=Ve(d,l),$=Te({getHeaders:b,getApiUrl:S});return Object.freeze({config:d,getHeaders:b,getApiUrl:S,fetch:(...C)=>p.fetch(...$(...C)),request:(...C)=>p.request(...$(...C)),requestStream:(...C)=>p.requestStream(...$(...C))})}function Fe(r,t,e){return n=>{n&&oe({...e,apiVersion:n});const o=(n??t).trim();return`${r}/api/${o}/graphql.json`}}function Ve(r,t){return e=>e?t(e):r.apiUrl}const v=`#graphql
fragment Media on Media {
  __typename
  mediaContentType
  alt
  previewImage {
    url
  }
  ... on MediaImage {
    id
    image {
      url
      width
      height
    }
  }
  ... on Video {
    id
    sources {
      mimeType
      url
    }
  }
  ... on Model3d {
    id
    sources {
      mimeType
      url
    }
  }
  ... on ExternalVideo {
    id
    embedUrl
    host
  }
}
`,P=`#graphql
  fragment Metaobject on Metaobject {
    id
    handle
    type
    fields {
      key
      type
      value
      reference {
        ... on GenericFile {
          id
          url
          mimeType
        }
        ... on Media {
          ...Media
        }
        ... on Metaobject {
          ...InnerMetaobject
        }
      }
      references(first: 250) {
        nodes {
          ... on Metaobject {
            ...InnerMetaobject
          }
        }
      }
    }
  }
`,F=`#graphql
  fragment InnerMetaobject on Metaobject {
    id
    handle
    type
    fields {
      key
      type
      value
      reference {
        ... on GenericFile {
          id
          url
          mimeType
        }
        ... on Media {
          ...Media
        }
        ... on Metaobject {
          id
          handle
          type
          fields {
            key
            type
            value
            reference {
              ...Media
            }
          }
        }
      }
      references(first: 250) {
        nodes {
          ... on GenericFile {
            id
            url
            mimeType
          }
          ... on Media {
            ...Media
          }
          ... on Metaobject {
            id
            handle
            type
            fields {
              key
              type
              value
              reference {
                ... on GenericFile {
                  id
                  url
                  mimeType
                }
                ... on Media {
                  ...Media
                }
                ... on Metaobject {
                  id
                  handle
                  type
                  fields {
                    key
                    type
                    value
                  }
                }
              }
              references(first: 250) {
                nodes {
                  ... on GenericFile {
                    id
                    url
                    mimeType
                  }
                  ... on Media {
                    ...Media
                  }
                  ... on Metaobject {
                    id
                    handle
                    type
                    fields {
                      key
                      type
                      value
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
`,Oe=`#graphql
  ${v}
  ${P}
  ${F}
  query metaobjects(
    $numLimit: Int!,
    $cursor: String,
    $type: String!,
    $country: CountryCode,
    $language: LanguageCode
  ) @inContext(
    country: $country,
    language: $language
  ) {
    metaobjects(first: $numLimit, after: $cursor, type: $type) {
      nodes {
        id
        handle
        type
        fields {
          key
          type
          value
          reference {
            ... on Metaobject {
              ...Metaobject
            }
            ... on GenericFile {
              id
              url
              mimeType
            }
            ... on Media {
              ...Media
            }
          }
          references(first: 250) {
            nodes {
              ... on Metaobject {
                ...Metaobject
              }
            }
          }
        }
      }
      pageInfo {
        hasNextPage
        endCursor
      }
    }
  }
`,Le=`#graphql
  ${v}
  ${P}
  ${F}
  query metaobjectById(
    $id: ID,
    $country: CountryCode,
    $language: LanguageCode
  ) @inContext(
    country: $country,
    language: $language
  ) {
    metaobject(id: $id) {
      id
      handle
      type
      fields {
        key
        type
        value
        reference {
          ... on Metaobject {
            ...Metaobject
          }
        }
        references(first: 250) {
          nodes {
            ... on Metaobject {
              ...Metaobject
            }
          }
        }
      }
    }
  }
`,Be=`#graphql
  ${v}
  query mediaById(
    $id: ID!
  ) {
    node(id: $id) {
      ... on MediaImage {
        ...Media
      }
    }
  }
`,qe=()=>{var a;const e=(a=window.Shopify)==null?void 0:a.shop;let n="",o="";switch(e){case"mymuesli-dev.myshopify.com":n="e1b1a18b200d8096f9a767852b20320b",o="7b716bf926dff9462574";break;case"mymuesli-test.myshopify.com":n="8ac0ecb3029cffda27d06dd0ad3ade63",o="7b716bf926dff9462574";break;case"mymuesli-prod.myshopify.com":n="148071bd7ceb7b42051cf185ef49884d",o="e03be71aaf0aff3e6680";break;case"mymuesli-ch-test.myshopify.com":n="1c140f5fde2e4f0bea57dc7cc7d885fc",o="7b716bf926dff9462574";break;case"mymuesli-ch-prod.myshopify.com":n="80c6148cbe40627d46299255c603e889",o="e03be71aaf0aff3e6680";break;case"mymuesli-patrick-dev.myshopify.com":n="6b92d1eb9cdbacb8286790a431fed193",o="7b716bf926dff9462574";break;case"stephdev-2.myshopify.com":n="b36effbf1db6716d62b447dece1aa9f3",o="7b716bf926dff9462574";break}return{isDevelopment:!1,isProduction:!0,apiBaseUrl:"/apps/app-proxy",storefrontDomain:e,storefrontAccessToken:n,storefrontApiVersion:"2025-04",uploadcarePublicKey:o}},w=qe(),He=`#graphql
  query metafields(
    $country: CountryCode,
    $language: LanguageCode
  ) @inContext(
    country: $country,
    language: $language
  ) {
    shop {
      mixerValidations: metafield(
        namespace: "custom",
        key: "mixer_validations"
      ) {
        id
        namespace
        key
        value
        type
      }
      designValidations: metafield(
        namespace: "custom",
        key: "design_validations"
      ) {
        id
        namespace
        key
        value
        type
      }
      ingredientValidations: metafield(
        namespace: "custom",
        key: "ingredient_validations"
      ) {
        id
        namespace
        key
        value
        type
      }
      mixerConfiguration: metafield(
        namespace: "custom",
        key: "mixer_configuration"
      ) {
        id
        namespace
        key
        value
        type
      }
      mixerBioLogo: metafield(
        namespace: "custom",
        key: "mixer_bio_logo"
      ) {
        id
        namespace
        key
        value
        type
        reference {
          ... on MediaImage {
            id
            image {
              url
              altText
            }
            mediaContentType
            alt
          }
        }
      }
      mixerCustomMixProduct: metafield(
        namespace: "custom",
        key: "mixer_custom_mix_product"
      ) {
        id
        namespace
        key
        value
        type
        reference {
          ... on Product {
            id
            title
            variants(first: 1) {
              edges {
                node {
                  id
                }
              }
            }
          }
        }
      }
      mixerBadwords: metafield(
        namespace: "custom",
        key: "mixer_badwords"
      ) {
        id
        namespace
        key
        value
        type
      }
    }
  }
`,Ge=`#graphql
  ${v}
  ${P}
  ${F}
  query metaobjectByHandle(
    $handle: MetaobjectHandleInput,
    $country: CountryCode,
    $language: LanguageCode
  ) @inContext(
    country: $country,
    language: $language
  ) {
    metaobject(handle: $handle) {
      id
      handle
      type
      fields {
        key
        type
        value
        reference {
          ... on Metaobject {
            ...Metaobject
          }
        }
        references(first: 250) {
          nodes {
            ... on Metaobject {
              ...Metaobject
            }
          }
        }
      }
    }
  }
`,m=[];for(let r=0;r<256;++r)m.push((r+256).toString(16).slice(1));function Je(r,t=0){return(m[r[t+0]]+m[r[t+1]]+m[r[t+2]]+m[r[t+3]]+"-"+m[r[t+4]]+m[r[t+5]]+"-"+m[r[t+6]]+m[r[t+7]]+"-"+m[r[t+8]]+m[r[t+9]]+"-"+m[r[t+10]]+m[r[t+11]]+m[r[t+12]]+m[r[t+13]]+m[r[t+14]]+m[r[t+15]]).toLowerCase()}let k;const Qe=new Uint8Array(16);function Ke(){if(!k){if(typeof crypto>"u"||!crypto.getRandomValues)throw new Error("crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported");k=crypto.getRandomValues.bind(crypto)}return k(Qe)}const Ye=typeof crypto<"u"&&crypto.randomUUID&&crypto.randomUUID.bind(crypto),H={randomUUID:Ye};function Xe(r,t,e){var o;if(H.randomUUID&&!r)return H.randomUUID();r=r||{};const n=r.random??((o=r.rng)==null?void 0:o.call(r))??Ke();if(n.length<16)throw new Error("Random bytes length must be >= 16");return n[6]=n[6]&15|64,n[8]=n[8]&63|128,Je(n)}class We{static generateUuid(){return Xe()}static async generateMixUid(t,e=12){const n=Math.min(e,12),o=typeof t=="string"?t:JSON.stringify(t),a=JSON.stringify(JSON.parse(o)),c=new TextEncoder().encode(a),s=await crypto.subtle.digest("SHA-256",c),u=Array.from(new Uint8Array(s)),l=btoa(String.fromCharCode.apply(null,u)).replace(/[+/=]/g,d=>d==="+"?"-":d==="/"?"_":"");return this.sanitizeToSafeAlphanumeric(l.substring(0,n))}static sanitizeToSafeAlphanumeric(t){const e="ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnpqrstuvwxyz23456789",n=/[^a-zA-Z0-9]|[oO0Il1]/g;return t.replace(n,()=>e.charAt(Math.floor(Math.random()*e.length)))}static generateTimestampId(t=""){const e=Date.now(),n=Math.random().toString(36).substring(2,8);return`${t}${e}_${n}`}static generateRandomId(t=8){const e="ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";let n="";for(let o=0;o<t;o++)n+=e.charAt(Math.floor(Math.random()*e.length));return n}static isValidUuid(t){return/^[0-9a-f]{8}-[0-9a-f]{4}-4[0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i.test(t)}static isValidMixUid(t){return!!(t&&t.length===12&&/^[A-Za-z0-9_-]+$/.test(t))}}class ze{static convertToGrams(t,e){if(!e)return 0;const n=e.toLowerCase();return/kg|kilogram(s)/.test(n)?t*1e3:/g|gram(s)/.test(n)?t:0}static formatUnit(t){const e=t.toLowerCase();return/^g|gram|grams$/i.test(e)?"g":/^kg|kilogram|kilograms$/i.test(e)?"kg":t}static formatWeight(t,e="g"){return`${t} ${this.formatUnit(e)}`}static isValidWeight(t,e,n){return t>=e&&t<=n}static calculateTotalWeight(t){return t.reduce((e,n)=>e+n,0)}}class ae{static encodeConfigurationPayload(t){const e=JSON.stringify(t);return btoa(e).replace(/\+/g,"-").replace(/\//g,"_").replace(/=+$/,"")}static decodeConfigurationPayload(t){let e=t.replace(/-/g,"+").replace(/_/g,"/");for(;e.length%4;)e+="=";const n=atob(e);return JSON.parse(n)}static encodeToBase64(t){const e=JSON.stringify(t);return btoa(e).replace(/\+/g,"-").replace(/\//g,"_").replace(/=+$/,"")}static decodeFromBase64(t){let e=t.replace(/-/g,"+").replace(/_/g,"/");for(;e.length%4;)e+="=";const n=atob(e);return JSON.parse(n)}static isValidConfigurationPayload(t){try{const e=this.decodeConfigurationPayload(t);return e&&typeof e=="object"}catch{return!1}}}class Ze{static async fetchMyMuesliApi(t,e){const n=w.apiBaseUrl;try{const o=await fetch(`${n}/${t}`,{method:"POST",headers:{"Content-Type":"application/json"},body:JSON.stringify(e)}),a=await o.json();return o.status!==200&&w.isDevelopment&&console.error("[MyMuesli API] Error fetching data",a),{result:o.status===200?a:null,status:o.status,error:o.status!==200?a:null}}catch(o){return w.isDevelopment&&console.error("[MyMuesli API] Error fetching data",o),{result:null,status:500,error:o}}}static async fetchMixConfiguration(t){try{const e=await this.fetchMyMuesliApi("custommixconfiguration",{mix_uid:t});return e.status===200?e.result.mix_configuration:(console.error(e.error),null)}catch(e){return console.error("Error fetching mix configuration:",e),null}}static async fetchIngredientsDeclaration(t,e,n){try{const o=await this.fetchMyMuesliApi("listofingredients",{ingredients:t,localeIdentifier:`${e.toLowerCase()||"de"}_${n.toUpperCase()||"DE"}`});if(o.error)throw o.error;return o.result}catch(o){return console.error("Error fetching ingredients declaration:",o),null}}static async fetchNutritionData(t,e,n){try{const o=await this.fetchMyMuesliApi("nutritions",{ingredients:t,perGram:"100",localeIdentifier:`${e.toLowerCase()||"de"}_${n.toUpperCase()||"DE"}`});if(o.error)throw o.error;return o.result}catch(o){return console.error("Error fetching nutrition data:",o),null}}static async fetchFlavorProfile(t){try{const e=await this.fetchMyMuesliApi("flavor",{ingredients:t});if(e.error)throw e.error;return e.result}catch(e){return console.error("Error fetching flavor profile:",e),null}}static async fetchAdditionalHints(t,e,n){try{const o=await this.fetchMyMuesliApi("additionalhints",{ingredients:t,localeIdentifier:`${e.toLowerCase()||"de"}_${n.toUpperCase()||"DE"}`});if(o.error)throw o.error;return o.result.additionalHints}catch(o){return console.error("Error fetching additional hints:",o),null}}static async fetchAllExternalApiData(t,e,n){const[o,a,i,c]=await Promise.all([this.fetchIngredientsDeclaration(t,e,n),this.fetchFlavorProfile(t),this.fetchNutritionData(t,e,n),this.fetchAdditionalHints(t,e,n)]);return{ingredientsDeclaration:o,flavour:a,nutrition:i,additionalHints:c}}}const x={language:"DE",country:"DE"},T=Pe({storeDomain:w.storefrontDomain,apiVersion:w.storefrontApiVersion,publicAccessToken:w.storefrontAccessToken});async function et(r,t,e){var o;return(o=(await T.request(Le,{variables:{id:r,country:t,language:e}})).data)==null?void 0:o.metaobject}async function tt(r,t,e){var o;return(o=(await T.request(Ge,{variables:{handle:r,country:t,language:e}})).data)==null?void 0:o.metaobject}async function N(r="",{list:t=[],cursor:e=void 0,numLimit:n=250,country:o="DE",language:a="DE"}={}){var i,c,s;try{const u=await T.request(Oe,{variables:{numLimit:n,type:r,country:o,language:a,cursor:e}}),f=((i=u.data)==null?void 0:i.metaobjects.pageInfo.hasNextPage)||!1,l=((c=u.data)==null?void 0:c.metaobjects.pageInfo.endCursor)||void 0,d=((s=u.data)==null?void 0:s.metaobjects.nodes)||[];return t=[...t,...d],f?await N(r,{list:t,cursor:l,numLimit:n,country:o,language:a}):t}catch(u){return console.error("Error fetching ingredients",u),[]}}const E=r=>{if(!r)return r;try{return JSON.parse(r)}catch{return r}},rt=r=>{var t;return((t=r.references)==null?void 0:t.nodes.map(e=>{if("fields"in e){const n={...M(e.fields),id:e.id};return Object.entries(n).reduce((a,[i,c])=>(c&&typeof c=="object"?"fields"in c?a[i]={...M(c.fields),id:c.id}:Array.isArray(c)?a[i]=c.map(s=>s&&typeof s=="object"&&"fields"in s?{...M(s.fields),id:s.id}:s):a[i]=c:a[i]=c,a),{})}else return e}))||[]},nt=r=>r.reference||r.value;function M(r){return r.reduce((t,e)=>{let n;switch(e.type){case"boolean":n=typeof e.value=="boolean"?e.value:typeof e.value=="string"?e.value==="true":e.value;break;case"color":n=e.value;break;case"date":n=e.value;break;case"date_time":n=e.value;break;case"dimension":n=E(e.value),"value"in n&&(n.value=y(n.value));break;case"id":n=e.value;break;case"json":n=E(e.value);break;case"link":n=E(e.value);break;case"money":n=E(e.value),"amount"in n&&(n.amount=y(n.amount));break;case"multi_line_text_field":n=e.value;break;case"number_decimal":n=y(e.value);break;case"number_integer":n=y(e.value);break;case"rating":n=E(e.value),"value"in n&&(n.value=y(n.value)),"scale_min"in n&&(n.value=y(n.value)),"scale_max"in n&&(n.value=y(n.value));break;case"rich_text_field":n=e.value;break;case"single_line_text_field":n=e.value;break;case"url":n=e.value;break;case"volume":n=E(e.value),"value"in n&&(n.value=y(n.value));break;case"weight":n=E(e.value),"value"in n&&(n.value=y(n.value));break;default:e.reference?n=nt(e):e.references?n=rt(e):n=e.value;break}return t[e.key]=n,t},{})}function y(r){if(typeof r=="number")return r;if(typeof r=="string"){const t=parseFloat(r);return Number.isNaN(t)?0:t}if(typeof r=="boolean")return r?1:0;if(r==null)return 0;try{const t=String(r),e=parseFloat(t);return Number.isNaN(e)?0:e}catch{return 0}}function ot(r){return r.map(t=>M(t.fields))}function at(r){return r.map(t=>M(t.fields))}function it(r){return M((r==null?void 0:r.fields)||[])}const ft=Ze.fetchMyMuesliApi;async function mt(r,t=20){var n;let e=0;for(;e<t;)try{const a=(n=(await T.request(Be,{variables:{id:r}})).data)==null?void 0:n.node;if(a)return e>0&&console.log(`Media image fetched successfully on attempt ${e+1}`),a;if(e<t-1)e++,console.log(`Media image fetch returned null, retrying... (attempt ${e+1}/${t})`),await new Promise(i=>setTimeout(i,1e3));else{console.warn(`Media image fetch failed after ${t} attempts - result was null`);return}}catch(o){console.error(`Error fetching media image on attempt ${e+1}:`,o);return}}function st(r){if(typeof r=="string")try{return JSON.parse(r)}catch(t){console.error("Failed to parse liquid data:",t)}return{bioLogoSrc:"",stickerSrc:"",fonts:{},baseModelSrc:"",customerId:"",i18n:{language:x.language,country:x.country,locale:`${x.language}_${x.country}`,translations:{}},configuration:"",decodedConfiguration:void 0,product:null,variant:null}}async function ct(r,t){var o;const e=await T.request(He,{variables:{country:r,language:t}}),n={};return Object.entries(((o=e.data)==null?void 0:o.shop)||{}).forEach(([a,i])=>{(i==null?void 0:i.type)==="json"&&(i.value=JSON.parse(i.value||"{}")),i!=null&&i.value&&(a==="mixerValidations"||a==="ingredientValidations"||a==="designValidations"?n[a]=i.value.validations:i!=null&&i.type.endsWith("_reference")&&"reference"in i&&(i!=null&&i.reference)?n[a]=i.reference:n[a]=i.value)}),n}async function ut(r,t,e,n){let o,a=null;if(r)try{a=await tt({type:"mixer_configuration",handle:r},e,n)}catch(s){console.error("Failed to fetch mixer configuration:",s)}else{const s=t.mixerConfiguration;try{a=await et(s,e,n)}catch(u){console.error("Failed to fetch mixer configuration:",u)}}if(!a)return{mixerConfiguration:null,ingredientFilters:[],ingredientUSPs:[]};o={...it(a),handle:a.handle};const i=await N("ingredient_filter",{country:e,language:n}).then(s=>ot(s)),c=await N("usp",{country:e,language:n}).then(s=>at(s));return{mixerConfiguration:o,ingredientFilters:i,ingredientUSPs:c}}async function pt(r,t){var c;const e=new URLSearchParams(window.location.search),n=st(r);let o=null;n.configuration&&(o=lt(n.configuration),n.decodedConfiguration=o,!t&&((c=o==null?void 0:o.configuration)!=null&&c.mixer_configuration_handle)&&(t=o.configuration.mixer_configuration_handle));const a=await ct(n.i18n.country,n.i18n.language),i=await ut(t,a,n.i18n.country,n.i18n.language);if(!i.mixerConfiguration)if(e.get("instance")){const s=new URL(window.location.href);s.searchParams.delete("instance"),window.location.href=s.toString()}else window.location.href="/404";return{mixerCustomMixProduct:a.mixerCustomMixProduct,mixerBioLogo:a.mixerBioLogo,mixerValidations:a.mixerValidations,ingredientValidations:a.ingredientValidations,designValidations:a.designValidations,mixerConfiguration:i.mixerConfiguration,ingredientFilters:i.ingredientFilters,ingredientUSPs:i.ingredientUSPs,mixerBadwords:a.mixerBadwords,liquidData:n}}const gt=ae.encodeConfigurationPayload,lt=ae.decodeConfigurationPayload;function G(r){return window.themeVendor.themeCurrency.formatMoney(r,window.theme.moneyFormat)}const dt=ze.formatUnit;function yt(r){const{price:t,weight:e}=r,n=t.amount*100;return typeof e=="object"&&e.value&&e.unit?`${G(n)} / ${e.value} ${dt(e.unit)}`:`${G(n)} / ${e} g`}function ht(){return We.generateUuid()}function bt(r){return String(r).replace(/&/g,"&amp;").replace(/"/g,"&quot;").replace(/'/g,"&#39;").replace(/</g,"&lt;").replace(/>/g,"&gt;")}function Et(r=10,t=500){return new Promise((e,n)=>{let o=0;const a=()=>{if(o++,"MyMuesli"in window&&window.MyMuesli.storage){e(window.MyMuesli.storage);return}if(o>=r){console.error(`MyMuesli storage service not available after ${r} attempts`),n(null);return}setTimeout(a,t)};a()})}function wt(r,t=0){let e;return typeof r=="string"?e=parseFloat(r):e=r,parseFloat(e.toFixed(t))}function Mt(r,t){let e=null;return(...n)=>{e&&clearTimeout(e),e=setTimeout(()=>r(...n),t)}}export{Ze as A,ae as E,We as I,ze as W,tt as a,pt as b,G as c,lt as d,gt as e,mt as f,wt as g,w as h,Mt as i,ft as j,yt as k,ht as l,bt as m,Et as w};
